const Favorites = () => {
  return (
    <div>
      <h1>Favorites</h1>
    </div>
  );
};

export default Favorites;
